// USE THIS FILE FOR TEMPORARY FUNCTIONS ex. FOR BETA TESTING
// PLEASE DELETE YOUR CODE ONCE NO LONGER NEEDED

import { UID } from '~/src/dash/utils/users';

// TODO: DELETE AFTER GA
export const TARGETING_PRESET_TEAM = [
  UID.jZamora,
  UID.vChao,
  UID.rSingh,
  // UID.bArimoto,
  // UID.kHufford1,
  // UID.kHufford2,
  // ...UX_TEAM_IDS,
  // UID.dKim,
  // UID.sCarr,
];
